export const UserType = Object.freeze({
  Member: 'Member',
  Coach: 'Coach',
  Admin: 'Admin',
});
